import { createTheme, responsiveFontSizes } from "@mui/material/styles";

const adminTheme = createTheme({
  typography: {
    fontFamily: `"Roboto", sans-serif`,
  },
});

export default responsiveFontSizes(adminTheme);
